module.exports = __webpack_public_path__ + "static/media/admin_selected.fd9fc41f.svg";